import useMapModalStore from '../../../../stores/useMapModalStore';
import DailyQuestsModal from '../../../../ui/modals/DailyQuestsModal';

/** Daily quests modal (`activeModal === 'dailyQuests'`). Fully store-driven. JSX moved verbatim. */
export default function DailyQuestsHost() {
  const isDailyQuestsModalOpen = useMapModalStore((s) => s.activeModal === 'dailyQuests');
  const closeModal = useMapModalStore((s) => s.closeModal);

  return (
        <DailyQuestsModal
          isOpen={isDailyQuestsModalOpen}
          onClose={closeModal}
        />
  );
}
